import { render } from "./DecisionReason.vue?vue&type=template&id=7c2449c3&scoped=true"
import script from "./DecisionReason.vue?vue&type=script&lang=js"
export * from "./DecisionReason.vue?vue&type=script&lang=js"

import "./DecisionReason.vue?vue&type=style&index=0&id=7c2449c3&scoped=true&lang=css"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c2449c3"]])

export default __exports__